<script>

    import TextField from './TextFieldComponent.svelte';
    import Dropdown from './DropDownComponent.svelte';
    import DateTimePicker from './DateTimePickerComponent.svelte';
    import NavBarReusable from './NavbarReusable.svelte';
    import SingleSelectCheckboxArea from './SingleSelectCheckboxArea.svelte';


    let selectedSubject = '';
    let topicsOfInterest = '';
    let selectedClass = '';
    let datetimeValues = [''];
    let showSuccessNotification = false;
    let showDuplicateNotification = false;
    let isSubmitting = false;
    let formSubmitted = false;

    const classChoices = [
        ['1', '1'],
        ['2', '2'],
        ['3', '3'],
        ['4', '4'],
        ['5', '5'],
        ['6', '6'],
        ['7', '7'],
        ['8', '8'],
        ['9', '9'],
        ['10', '10'],
        ['11', '11'],
        ['12', '12'],
        ['13', 'Universitetas'],
    ];

    const addDateTime = () => {
        datetimeValues = [...datetimeValues, ''];
    };

    const removeDateTime = (index) => {
        datetimeValues = datetimeValues.filter((_, i) => i !== index);
    };

    const checkForDuplicateRegistration = async (subjects, topics, selectedClass) => {
        const token = localStorage.getItem('jwtToken');
        
        try {
            // We'll check existing registrations by fetching user's registration history
            // Since there's no specific duplicate check endpoint, we'll create one or use existing data
            
            // For now, we'll implement a simple check by calling a new endpoint
            const response = await fetch('/studentplayground/api/check-duplicate-registration/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    subjects: subjects,
                    topics: topics,
                    selectedClass: selectedClass
                })
            });

            if (response.ok) {
                const result = await response.json();
                return result.isDuplicate;
            }
            
            // If endpoint doesn't exist yet, we'll fall back to manual check
            // This is a temporary solution until backend is updated
            return false;
            
        } catch (error) {
            console.log('Duplicate check not available, proceeding with submission');
            return false;
        }
    };

    const handleSubmit = async () => {
        // Prevent multiple submissions only while currently submitting
        if (isSubmitting) {
            return;
        }

        // Basic validation
        if (!selectedSubject) {
            alert('Prašome pasirinkti dalyką.');
            return;
        }
        if (!selectedClass) {
            alert('Prašome pasirinkti klasę.');
            return;
        }
        if (datetimeValues.length === 0 || datetimeValues.every(dt => !dt)) {
            alert('Prašome pasirinkti bent vieną laiką.');
            return;
        }

        isSubmitting = true;

        // Check for duplicate registration
        const isDuplicate = await checkForDuplicateRegistration([selectedSubject], topicsOfInterest, selectedClass);
        
        if (isDuplicate) {
            // Show styled duplicate notification instead of alert
            showDuplicateNotification = true;
            // Auto-hide notification after 10 seconds
            setTimeout(() => {
                showDuplicateNotification = false;
            }, 10000);
            isSubmitting = false;
            return;
        }

        const data = {
            subjects: [selectedSubject],
            topics: topicsOfInterest,
            selectedClass: selectedClass,
            datetimeValues: datetimeValues.filter(dt => dt), // Remove empty datetime values
        };
        const token = localStorage.getItem('jwtToken'); 
        
        try {
            const response = await fetch('/studentplayground/registerForClass/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCookie('csrftoken'),
                    'Authorization': `Bearer ${token}`  // Include JWT token in Authorization header
                    },
                    credentials: 'include',
                    body: JSON.stringify(data)  // Optionally include credentials if using cookies
                    });
                

                    if (response.ok) {
                        // Show success notification instead of redirecting
                        showSuccessNotification = true;
                        // Auto-hide notification after 10 seconds
                        setTimeout(() => {
                            showSuccessNotification = false;
                        }, 10000);
                        
                        // Clear form data to allow new submissions for different classes
                        selectedSubject = '';
                        topicsOfInterest = '';
                        selectedClass = '';
                        datetimeValues = [''];
                        
                        // Reset formSubmitted to allow new submissions (removed the formSubmitted = true line)
                        
                    } else {
                        if (response.status === 401) {
                            // If response is 401 Unauthorized, redirect to login
                            alert('Reikia prisijungti iš naujo.');
                            localStorage.removeItem('jwtToken'); // Optional: Clear any stored tokens
                            window.location.href = '#/about'; // Redirect to login page
                        } else if (response.status === 400) {
                            // Check if it's a duplicate registration error
                            try {
                                const errorData = await response.json();
                                if (errorData.message && errorData.message.includes('Duplicate registration')) {
                                    // Show styled duplicate notification instead of alert
                                    showDuplicateNotification = true;
                                    // Auto-hide notification after 10 seconds
                                    setTimeout(() => {
                                        showDuplicateNotification = false;
                                    }, 10000);
                                } else {
                                    alert('Klaida pateikiant formą. Prašome bandyti vėl.');
                                }
                            } catch {
                                alert('Klaida pateikiant formą. Prašome bandyti vėl.');
                            }
                        } else {
                            // Handle other errors
                            alert('Klaida pateikiant formą. Prašome bandyti vėl.');
                        }
                    }
        } catch (error) {
            console.error('Error:', error);
            alert('Įvyko klaida. Prašome bandyti vėl.');
        } finally {
            isSubmitting = false;
        }
    };

    function getCookie(name) {
        let cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
</script>
<NavBarReusable label="Registruotis" />

<!-- Success Notification -->
{#if showSuccessNotification}
    <div class="notification success-notification">
        <div class="notification-content">
            <span class="notification-icon">✓</span>
            <div class="notification-text">
                <strong>Registracija sėkminga!</strong>
                <p>Jūsų registracija išsaugota. Tutory komanda su jumis susisieks artimiausiu metu.</p>
            </div>
            <button class="close-notification" on:click={() => showSuccessNotification = false}>×</button>
        </div>
    </div>
{/if}

<!-- Duplicate Notification -->
{#if showDuplicateNotification}
    <div class="notification duplicate-notification">
        <div class="notification-content">
            <span class="notification-icon">ℹ</span>
            <div class="notification-text">
                <strong>Užklausa jau egzistuoja</strong>
                <p>Tikslią šios pamokos užklausą jau matome. Su jumis artimu metu susisieks Tutory administratoriai dėl registracijos patvirtinimo.</p>
            </div>
            <button class="close-notification" on:click={() => showDuplicateNotification = false}>×</button>
        </div>
    </div>
{/if}

<div class="student-form">
    <h2>Pasirinkite pamoką</h2>
    <SingleSelectCheckboxArea bind:selectedSubject={selectedSubject} />

    <TextField 
        label="Nuo kurios temos norėtumėte pradėti?" 
        placeholder="Įrašykite specifines temas, kurios jus domina" 
        bind:value={topicsOfInterest} 
    />

    <Dropdown 
        label="Pasirinkite klasę"
        options={classChoices}
        bind:selectedValue={selectedClass}
    />
    <!-- Dynamic DateTime Picker List -->
    {#each datetimeValues as datetimeValue, index}
        <DateTimePicker 
            id={`datetime-${index}`} 
            bind:value={datetimeValues[index]} 
            onRemove={() => removeDateTime(index)} 
        />
    {/each}
    
    <button type="button" class='addDatetime' on:click={addDateTime}>Pridėti laiką</button>

    <button on:click={handleSubmit} type="button" class="submitBut" disabled={isSubmitting}>
        {#if isSubmitting}
            Siunčiama...
        {:else}
            Pateikti Užklausą
        {/if}
    </button>
</div>
<style>
    .submitBut{
        background-color: #fab45a;
        color:black;
        border: 1px solid #000000;

    }
    .submitBut:hover:not(:disabled){
        background-color: #c98f43;
        
        color:black;
    }
    .submitBut:disabled{
        background-color: #d1d5db;
        color: #6b7280;
        cursor: not-allowed;
        opacity: 0.6;
    }
    
    .student-form {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    
    .addDatetime{
        display: flex;
        justify-content: center;
        align-items: center;
        height:40px;
        background-color: #fab45a;
        color:black;
    }
    .addDatetime:hover{
        background-color: #c98f43;
        color:black;
    }

    button{
        margin-top: 20px;
        height: 60px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 12px 20px;
        gap: 10px;
        border-radius: 6px;
        border: 1px solid #333;
        font-weight: bold;
        font-size: large;
        background: transparent;
        box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
        border-radius: 8px;
        transition: background-color 0.3s ease, color 0.3s ease; /* Add color transition */
    }
    button:hover {
        background-color: #14695b;
        color:white;
    }

    /* Notification Styles */
    .notification {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        padding: 16px;
        animation: slideDown 0.3s ease-out;
    }

    .success-notification {
        background-color: #d4edda;
        border-bottom: 3px solid #28a745;
        color: #155724;
    }

    .duplicate-notification {
        background-color: #fff3cd;
        border-bottom: 3px solid #ffc107;
        color: #856404;
    }

    .notification-content {
        display: flex;
        align-items: center;
        max-width: 1200px;
        margin: 0 auto;
        gap: 12px;
    }

    .notification-icon {
        font-size: 24px;
        font-weight: bold;
        color: #28a745;
        background-color: white;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .notification-text {
        flex: 1;
    }

    .notification-text strong {
        display: block;
        font-size: 16px;
        margin-bottom: 4px;
    }

    .notification-text p {
        margin: 0;
        font-size: 14px;
        opacity: 0.9;
    }

    .close-notification {
        background: none;
        border: none;
        font-size: 24px;
        font-weight: bold;
        cursor: pointer;
        color: #155724;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        transition: background-color 0.2s ease;
        margin: 0;
        padding: 0;
        flex-shrink: 0;
    }

    .close-notification:hover {
        background-color: rgba(21, 87, 36, 0.1);
        color: #155724;
    }

    @keyframes slideDown {
        from {
            transform: translateY(-100%);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
   
</style>
